//#region IMPORTS
import {
  SHOW_SUBORDER_INFO,
  UPDATE_SUBORDER_TRACKINGFORM_MODAL,
} from "../../models/_consts";
import { BoltSlashIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
import { setSelectedSubOrder } from "../../features/orders/ordersSlice";
import { useAppDispatch } from "../../store/configureStore";
import { useTranslation } from "react-i18next";
import { openModal } from "../../features/dashBoard/dashboardSlice";
import { SubOrder } from "../../models/suborder";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
import { Order } from "../../models/order";
import OrderStatusControl from "./OrderStatusControl";
import OrderParcelCount from "./OrderParcelCount";
//#endregion

//#region INTERFACE
interface Props {
  isPicker?: boolean;
  isHQTeam?: boolean;
  isAdmin?: boolean;
  subOrder: SubOrder;
  order: Order;
}
//#endregion

export default function OrdersTableRowSubOrder({
  subOrder,
  isPicker = false,
  isHQTeam = false,
  isAdmin = false,
  order,
}: Props) {
  //#region SETUP
  // Translation
  const { t } = useTranslation();

  // Redux
  const dispatch = useAppDispatch();
  //#endregion

  //#region LOGIC
  // Show modal
  const showSuborderActionModal = (type: string) => {
    dispatch(setSelectedSubOrder({ subOrder, order }));
    dispatch(openModal(type));
  };
  //#endregion

  //#region RENDER
  return (
    <tr>
      {/* Checkbox */}
      {(isAdmin || isPicker || isHQTeam) && <td className="relative"></td>}
      {/* Read */}
      <td className="pr-2 py-1 text-xs text-gray-500 sm:pl-0"></td>
      {/* Store */}
      {!isAdmin && !isPicker && !isHQTeam && <td className="relative"></td>}
      {/* Project */}
      <td className="pr-2 py-1"></td>
      {/* Order date */}
      <td className="pr-2 py-1"></td>
      {/* Ordercode */}
      <td className="pr-2 py-1"></td>
      {/* Parcel ammount */}
      <td className="px-2 py-1 text-xs text-gray-900 border-t border-white bg-gray-100">
        <OrderParcelCount order={order} subOrder={subOrder} />
      </td>
      {/* Order status */}
      <td className="pr-2 py-1 text-xs text-gray-900 border-t border-white bg-gray-100">
        <OrderStatusControl currentStatus={subOrder.order_status} />
      </td>
      {/* Items */}
      <td className="pr-2 py-1 text-xs text-gray-900 border-t border-white bg-gray-100">
        <span className="font-bold">
          {
            order.order_items.filter(
              (orderItem) => orderItem.sub_order_id === subOrder.id,
            ).length
          }
        </span>
        {isAdmin || isPicker || isHQTeam ? (
          <span>{` by ${subOrder.suppliers.split("(")[0]}`}</span>
        ) : (
          <span>{` item${
            order.order_items.filter(
              (orderItem) => orderItem.sub_order_id === subOrder.id,
            ).length > 1
              ? "s"
              : ""
          }`}</span>
        )}
      </td>
      {/* Comment */}
      <td className="pr-2 py-1 text-xs text-gray-900 border-t border-white bg-gray-100">
        {subOrder.transsmart.track_and_trace_url ? (
          <a
            href={subOrder.transsmart.track_and_trace_url}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center rounded-full bg-emerald-500 px-2 py-0.5 text-[10px] font-medium text-white hover:bg-emerald-400 hover:text-emerald-900"
          >
            TRACK PARCEL
          </a>
        ) : (
          <div className="text-sm">
            <BoltSlashIcon
              className="w-4 h-4 text-indigo-800"
              data-tooltip-id={subOrder.id.toString() + "noTrackingInfo"}
              data-tooltip-content="No tracking information available"
              data-tooltip-variant="info"
            />
            <Tooltip id={subOrder.id.toString() + "noTrackingInfo"} />
          </div>
        )}
      </td>
      {/* Parcel info */}
      <td className="pr-2 py-1 text-xs text-gray-900 border-t border-white bg-gray-100">
        <div className="flex items-center gap-x-4">
          <button
            onClick={() => showSuborderActionModal(SHOW_SUBORDER_INFO)}
            className="inline-flex items-center rounded-full bg-sky-200 px-2 py-0.5 text-[10px] font-medium text-sky-900 hover:text-white hover:bg-sky-600"
          >
            {t("rituals.parcelDetail").toUpperCase()}
          </button>

          {(isAdmin || isPicker || isHQTeam) && (
            <Fragment>
              <button
                data-tooltip-id={subOrder.id.toString() + "editTrackingModal"}
                data-tooltip-content={t("rituals.updateTrackingCode")}
                onClick={() =>
                  showSuborderActionModal(UPDATE_SUBORDER_TRACKINGFORM_MODAL)
                }
                className="inline-flex items-center text-sm"
              >
                <PencilSquareIcon className="text-indigo-800 w-4 h-4 hover:text-indigo-500" />
                <Tooltip id={subOrder.id.toString() + "editTrackingModal"} />
              </button>
            </Fragment>
          )}
        </div>
      </td>
      {isHQTeam && (
        <td className="pr-2 py-1 text-xs text-gray-900 border-t border-white bg-gray-100"></td>
      )}
    </tr>
  );
  //#endregion
}
